module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/10ce7deabcbf4cccb17cca2621b94345.png";